import { Tabs, TabsHeader, Tab } from '@material-tailwind/react';
import { Drawer } from '@material-tailwind/react';
import { Fragment, useEffect, useState } from 'react';
import Buttons from '../../../components/common/Buttons';
import TextWinds from '../../../components/common/TextWinds';
import RegistDetail from './popup/RegistDetail';
import Modify from './popup/Modify';
import StudentList from './StudentList';
import {
  studentStatusType,
  studentType,
} from '../../../constants/types/student-type';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { PaginationProps } from '../../../constants/types';
import { getStudentList } from '../../../api/utils/lms/lmsApi';
import { PAGE_SIZE } from '../../../constants/constants';
import HFbutton from '../../../components/common/input/HFbutton';

const TABS_MENU = [
  {
    label: '수강생',
    value: studentStatusType.ACTIVE,
  },
  {
    label: '정지',
    value: studentStatusType.INACTIVE,
  },
  {
    label: '대기생',
    value: studentStatusType.PENDING,
  },
];

const Signupmgmt = () => {
  const navigate = useNavigate();
  const { classId } = useParams();

  // --- SearchParams ---
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab =
    (searchParams.get('status') as studentStatusType) ||
    studentStatusType.PENDING;
  const page = searchParams.get('page') ? +searchParams.get('page') : 1;
  const pageSize = searchParams.get('pageSize')
    ? +searchParams.get('pageSize')
    : PAGE_SIZE;

  // --- 드로어 관리 ---
  const [signupModalOpen, setSignupModalOpen] = useState(false);
  const [modifyModalOpen, setModifyModalOpen] = useState<boolean>(false);

  const [studentList, setStudentList] = useState<studentType[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [pageInfo, setPageInfo] = useState<PaginationProps>({
    page,
    pageSize,
    lastPage: 0,
    total: 0,
  });

  useEffect(() => {
    if (signupModalOpen || modifyModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }

    return () => {
      document.body.style.overflow = 'visible';
    };
  }, [signupModalOpen, modifyModalOpen]);

  useEffect(() => {
    reloadStudentList();
  }, [activeTab, page, pageSize]);

  // 페이지 정보 변경에 따른 학생 리스트 가져오기
  const reloadStudentList = () => {
    setIsLoading(true);

    getStudentList(classId, activeTab, page, pageSize)
      .then((res) => {
        if (page > 1 && res.result.length === 0) {
          searchParams.set('page', res.page.lastPage.toString());
          setSearchParams(searchParams);
          return;
        }

        setStudentList(res.result);
        setPageInfo({
          page,
          pageSize,
          total: res.page.total,
          lastPage: res.page.lastPage,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex flex-col pt-6 xl:px-5">
      {/* 헤더 */}
      <header className="flex flex-col gap-3 px-5 xl:px-0">
        <TextWinds type="title_h2" xlType="title_h3">
          학생 관리
        </TextWinds>
        {/* div : 버튼 너비 조정 래퍼 */}
        <div className="xl:w-[300px]">
          <HFbutton
            height={36}
            type="Outlined"
            onClick={() => navigate(`/lms/${classId}/migration`)}
          >
            구버전 학생 가져오기
          </HFbutton>
        </div>
      </header>

      <div className="my-5 flex flex-col gap-x-1 bg-white p-4 xl:rounded-lg xl:p-4 xl:pt-6 xl:shadow-card">
        <section className="flex items-center justify-center gap-3 border-b border-gray5 pb-5 xl:justify-end">
          {/* div : 버튼 너비 조정 래퍼 */}
          <div className="w-32">
            <Buttons
              type="filled"
              color="purple5"
              isHeight="titlebutton"
              onClick={() => setSignupModalOpen(true)}
              className="h-10 w-full"
            >
              학생 추가
            </Buttons>
          </div>
          <div className="w-32">
            <Buttons
              type="outlined"
              color="purple5"
              isHeight="titlebutton"
              onClick={() => setModifyModalOpen(true)}
              className="h-10 w-full"
            >
              반 추가/수정
            </Buttons>
          </div>
        </section>

        {/* 탭 */}
        <Tabs value={activeTab} className="w-full">
          <TabsHeader
            className="rounded-none border-b border-gray6 bg-transparent p-0"
            indicatorProps={{
              className:
                'bg-transparent border-b-0 border-purple5 shadow-none rounded-none',
            }}
          >
            {TABS_MENU.map(({ label, value }) => (
              <Tab
                key={value}
                value={value}
                onClick={() => setSearchParams({ status: value })}
                className={`h-[48px] w-[142px] border-b-${
                  activeTab === value ? '2' : '0'
                } border-purple5`}
              >
                <div className="flex">
                  <TextWinds
                    type={`${
                      activeTab === value ? 'button2' : 'content_body3'
                    }`}
                    color={`${activeTab === value ? 'purple5' : 'gray7'}`}
                    xlType={`${
                      activeTab === value ? 'button' : 'content_body2'
                    }`}
                  >
                    {label}
                  </TextWinds>
                </div>
              </Tab>
            ))}
          </TabsHeader>
        </Tabs>

        {/* 중앙 테이블  */}
        <StudentList
          status={activeTab}
          data={studentList}
          pageInfo={pageInfo}
          reloadStudentList={reloadStudentList}
          isLoading={isLoading}
        />

        {/* 학생 등록 모달 */}
        <Drawer
          placement="bottom"
          open={signupModalOpen}
          onClose={() => {
            setSignupModalOpen(false);
          }}
          overlay={true}
          size={608}
          className="left-0 right-1/4 max-h-[100%] w-full items-center overflow-y-auto rounded-t-xl px-5 py-2.5 lg:left-1/4 lg:w-1/2"
        >
          <RegistDetail
            title="학생 등록"
            open={signupModalOpen}
            closeDrawerBottom={() => {
              setSignupModalOpen(false);
            }}
            reloadStudentList={reloadStudentList}
          />
        </Drawer>

        {/* 반 등록 모달 */}
        <Drawer
          placement="bottom"
          open={modifyModalOpen}
          onClose={() => {
            setModifyModalOpen(false);
          }}
          overlay={true}
          size={485}
          className="left-0 right-1/4 max-h-[100%] w-full items-center overflow-y-auto rounded-t-xl px-5 py-4 lg:left-1/4 lg:w-1/2"
        >
          <Modify
            title="반 등록하기"
            closeDrawerBottom={() => {
              setModifyModalOpen(false);
            }}
            open={modifyModalOpen}
          />
        </Drawer>
      </div>
    </div>
  );
};

export default Signupmgmt;
